import Card from "../UI/Card";
import TextArea from "../UI/TextArea";
import { Form, Formik } from "formik";
import useAuthenticatedAxios from "../../hooks/use-authenticated-axios";
import { useState } from "react";
import FormikSubmitButton from "../UI/FormikSubmitButton";

export default function Imports() {
  const axios = useAuthenticatedAxios();
  const [response, setResponse] = useState(null);
  async function submitHandler(values) {
    try {
      const response = await axios.post(`/imports/${values.type}`, {
        csv: values.csv,
      });
      setResponse(response.data);
    } catch (error) {
      console.error(error);
      setResponse(error);
    }
  }
  return (
    <>
      <Card>
        <Formik
          initialValues={{ csv: "", type: "properties" }}
          enableReinitialize={true}
          onSubmit={submitHandler}
        >
          {() => (
            <Form>
              <TextArea
                type="text"
                name="csv"
                label="Propriétés CSV"
                rows="4"
              />
              <div className={"text-right"}>
                <FormikSubmitButton>Valider</FormikSubmitButton>
              </div>
            </Form>
          )}
        </Formik>
        {response && <Card className={"marginT10"}>{response}</Card>}
      </Card>{" "}
      <Card className={"marginT10"}>
        <Formik
          initialValues={{ csv: "", type: "tenants" }}
          enableReinitialize={true}
          onSubmit={submitHandler}
        >
          {() => (
            <Form>
              <TextArea
                type="text"
                name="csv"
                label="Locataires CSV"
                rows="4"
              />
              <div className={"text-right"}>
                <FormikSubmitButton>Valider</FormikSubmitButton>
              </div>
            </Form>
          )}
        </Formik>
        {response && <Card className={"marginT10"}>{response}</Card>}
      </Card>
      <Card className={"marginT10"}>
        <Formik
          initialValues={{ csv: "", type: "balances" }}
          enableReinitialize={true}
          onSubmit={submitHandler}
        >
          {() => (
            <Form>
              <TextArea type="text" name="csv" label="Balances CSV" rows="4" />
              <div className={"text-right"}>
                <FormikSubmitButton>Valider</FormikSubmitButton>
              </div>
            </Form>
          )}
        </Formik>
        {response && <Card className={"marginT10"}>{response}</Card>}
      </Card>
    </>
  );
}
